import { queryApi } from "lib/api";
import {
    CertificationParams,
    CertificationResponse,
    OrderRegistParam,
    OrderRegistResponse,
} from "./type";

export const callCertificationApi = (
    data: CertificationParams
): Promise<CertificationResponse> => queryApi("/channel/account/join", data);

export const callOrderRegistApi = (
    data: OrderRegistParam
): Promise<OrderRegistResponse> => queryApi("/mint/order/set", data);
